import React from 'react';
import '../css/skeleton.css';
import '../css/normalize.css';
import '../css/components.css';

function Playlist() {
  return (
    <div className="playlist-container industrial-card">
      {/* Corner Ticks */}
      <div className="corner-tick top-left">+</div>
      <div className="corner-tick top-right">+</div>
      <div className="corner-tick bottom-left">+</div>
      <div className="corner-tick bottom-right">+</div>

      <div className="playlist-header-bar">
        <div className="audio-status">
          <span className="live-pulse"></span>
          <span className="mono-label">AUDIO_STREAM // SOUNDCLOUD</span>
        </div>
        <div className="playlist-spec">
          <span>CURATION: &ldquo;WAV&rdquo;</span>
        </div>
      </div>

      <div className="iframe-wrapper">
        <iframe
          title="SoundCloud Audio Playlist"
          width="100%"
          height="166"
          scrolling="no"
          frameBorder="no"
          allow="autoplay"
          src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/soundcloud%253Aplaylists%253A2046995574&color=%23ff4500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false"
        />
      </div>

      <div className="playlist-footer-bar">
        <a
          href="https://soundcloud.com/thankyoudom"
          title='(ಠ_ಠ) "dom"'
          target="_blank"
          rel="noopener noreferrer"
          className="audio-link"
        >
          ARTIST: (ಠ_ಠ) &ldquo;DOM&rdquo;
        </a>
        <span className="divider">•</span>
        <a
          href="https://soundcloud.com/thankyoudom/sets/wav"
          title="wav"
          target="_blank"
          rel="noopener noreferrer"
          className="audio-link"
        >
          PLAYLIST: WAV
        </a>
      </div>
    </div>
  );
}

export default Playlist;